//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default{
		props:['orgCode'],
		data(){
			return{
        leagueId: null,
        leagueName: null,
        showLeagueList: false,
        leagueList: []
			}
		},
		mounted(){
			this.hagkHttp(this.hagkApi.getLeagueList(this.orgCode), {})
			.then((res) => {
				if(res.status){
          this.leagueList = res.result;
				}
			}, (error) => {
				console.log(error);
				window.alert('联赛列表获取失败！');
			})
		},
		methods:{
			changeLeague(leagueId, leagueName){
        this.showLeagueList = false;
			  this.leagueId = leagueId;
			  this.leagueName = leagueName;
				this.$emit('changeLeague', leagueId);
			}
		},
    filters: {
      subfilter:function(value,sublength){
        if (!value) return ''
        value = value.toString()
        if(value.length > sublength){
          return value.substr(0,sublength)+"...";
        }
        return value;
      }
    }
	}



// WEBPACK FOOTER //
// ./src/components/LeagueListHead.vue